import React from "react";
import { Routes, Route } from 'react-router-dom';

import CallerDashboard from './../Pages/Caller/Dashboard';
import CallerLeads from './../Pages/Caller/Leads/Lead';
import CallerLeadFilter from './../Pages/Caller/Leads/LeadFilter';
import CallerLeadEdit from './../Pages/Caller/Leads/EditLead';
import CallerLeadProfile from './../Pages/Caller/Leads/LeadProfile';

import CallerActivityLogs from './../Pages/Caller/Logs';

import CallerNotifications from './../Pages/Caller/Notification';
import CallerNotificationFilterDataList from './../Pages/Caller/NotificationFilterDataList';
import CallerRemarks from './../Pages/Caller/Remarks';

import Reports from './../Pages/Caller/Reports/Report';

import CallerProfile from './../Pages/Caller/CallerProfile';


//import AuthChecker from './../Pages/AuthenticationChecker';

//import NotFound from './../Pages/NotFound';

const Caller = [
    {
        path: "caller/dashboard", 
        element: <CallerDashboard />,
    },
    {
        path: "caller/leads", 
        element: <CallerLeads />,
    },
    {
        path: "caller/lead/:leadid/edit", 
        element: <CallerLeadEdit />,
    },
    {
        path: "caller/lead/:filtertype", 
        element: <CallerLeadFilter />,
    },
    {
        path: "caller/remarks", 
        element: <CallerRemarks />,
    },
    {
        path: "caller/activity-logs", 
        element: <CallerActivityLogs />,
    },
    {
        path: "caller/notifications", 
        element: <CallerNotifications />,
    },
    {
        path: "caller/notification/:filtertype", 
        element: <CallerNotificationFilterDataList />,
    },
    {
        path: "caller/profile", 
        element: <CallerProfile />,
    },
    {
        path: "caller/lead-profile/:leadid", 
        element: <CallerLeadProfile />,
    },
];

/*const Caller = () =>{

    return(
    <Routes>
        <Route element={<AuthChecker />}>
        <Route path="caller/dashboard" element={<CallerDashboard />} />
        <Route path="caller/leads" element={<CallerLeads />} />
        <Route path="caller/lead/:leadid/edit" element={<CallerLeadEdit />} />

        <Route path="caller/remarks" element={<CallerRemarks />} />
        <Route path="caller/activity-logs" element={<CallerActivityLogs />} />

        <Route path="caller/notifications" element={<CallerNotifications />} />

        <Route path="team/reports" element={<Reports />} />

        <Route path="*" element={<NotFound />} />
        </Route>
    </Routes>
    );
}*/

export default Caller;